/* unplugin-vue-components disabled */import script from "./SalesCompanyCount.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesCompanyCount.vue?vue&type=script&setup=true&lang=js"

import "./SalesCompanyCount.vue?vue&type=style&index=0&id=ff01e814&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff01e814"]])

export default __exports__